export enum UserRole {
    Internal = "Internal",
    Vendor = "Vendor",
    SubVendor = "SubVendor",
    AccountPayable = "AccountPayable",
    Admin = "Admin"
}
